// Helpers partagés des vues Data (extraits de DataTab.js).

export function KPICard({ icon: Icon, label, value, subValue, color }) {
  const colors = {
    emerald: "bg-emerald-50 text-emerald-600",
    blue: "bg-blue-50 text-blue-600",
    purple: "bg-purple-50 text-purple-600",
    amber: "bg-amber-50 text-amber-600",
    teal: "bg-teal-50 text-teal-600",
    red: "bg-red-50 text-red-600",
  };

  return (
    <div className="dash-card">
      <div className="flex items-center gap-3">
        <div className={`p-3 rounded-xl ${colors[color]}`}>
          <Icon className="w-5 h-5" />
        </div>
        <div>
          <p className="text-2xl font-bold text-slate-800">{value}</p>
          <p className="text-sm text-slate-500">{label}</p>
          {subValue && <p className="text-xs text-slate-400">{subValue}</p>}
        </div>
      </div>
    </div>
  );
}

export function AlertBadge({ level, triggered }) {
  if (!triggered && !level) return <span className="text-slate-300">—</span>;
  
  const configs = {
    CRITICAL: { bg: "bg-red-100", text: "text-red-700", label: "Critique" },
    ORANGE: { bg: "bg-orange-100", text: "text-orange-700", label: "Orange" },
    VERT: { bg: "bg-green-100", text: "text-green-700", label: "Vert" },
  };
  
  const config = configs[level] || configs.VERT;
  
  return (
    <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.text}`}>
      {config.label}
    </span>
  );
}

// Format symptom score (0-3) with visual indicator
export function formatScore(score) {
  if (score === null || score === undefined) return <span className="text-slate-300">—</span>;
  
  const colors = ["text-green-600", "text-yellow-600", "text-orange-600", "text-red-600"];
  const labels = ["0", "1", "2", "3"];
  
  return (
    <span className={`font-medium ${colors[score] || "text-slate-400"}`}>
      {labels[score] || score}
    </span>
  );
}

// Compact score format for research view
export function formatScoreCompact(score) {
  if (score === null || score === undefined) return <span className="text-slate-300">—</span>;
  
  const colors = {
    0: "bg-green-100 text-green-700",
    1: "bg-yellow-100 text-yellow-700",
    2: "bg-orange-100 text-orange-700",
    3: "bg-red-100 text-red-700",
  };
  
  return (
    <span className={`px-1.5 py-0.5 rounded text-xs font-medium ${colors[score] || "bg-slate-100 text-slate-600"}`}>
      {score}
    </span>
  );
}

export const QUALITY_LABELS = {
  cancerTypePct: "Type de cancer renseigné",
  treatmentTypePct: "Traitement renseigné",
  protocolPct: "Protocole patient renseigné",
  therapeuticLinePct: "Ligne thérapeutique renseignée",
  patientsWithCheckinPct: "Patients avec check-in",
  patientsWithOralAdherencePct: "Patients avec observance per os",
};
